var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({borderBottom:_vm.border ? '1px solid #e8e8e8':'none'}),attrs:{"id":"global-title"}},[_c('div',{staticClass:"content-view"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"operation-view"},[_vm._t("operate")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cf6f012","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/title.vue
// module id = null
// module chunks = 